export default function Location() {
    return(
        <section id="location" class="container-fluid">
          <div class="container pt-5">
            <div class='row d-flex align-content-center'>
               <div class='col-lg-4 col-md-5 mx-auto'>
                  <h1 class='display-6 text-danger'>
                    Domicilio</h1>
                  <p class='lead'>Mariscos Y Loncheria La Paz</p>
                  <p a class='lead '><i class="bi bi-phone"></i> <a className='lead text-danger' href="tel:3921060763">Tel: 392 10 60 763</a></p>
                  <p className="lead"><i class="bi bi-geo-alt"></i>Juarez #47 </p>
                  <p class='lead'><i class="bi bi-geo-alt"></i> Jamay, Jalisco 47900</p>
               </div>
               <div class="col-lg-8 col-md-7">
                 <iframe class="shadow-lg rounded-3" width="100%" height="250px" title='barciastech' src="https://maps.google.com/maps?q=Juárez%20%47%20Centro%20Jamay%20Jalisco%2047900&t=&z=14&ie=UTF8&iwloc=&output=embed" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0"></iframe>
               </div>
            </div>
          </div>
        <div class="container text-center pt-5 pb-3">
            <p>Creado por:</p>
            <a class='text-dark pb-5' href="http://barciastech.com/es">Barcias Tech</a>
        </div>
    
        </section>
    )
}